// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "item-dHhQF";
var _3 = "avatar-32dQg";
var _4 = "select-2letY";
var _5 = "item_recommend-1Digo";
var _6 = "item_active-3pllX";
var _7 = "clear-1Ger_";
var _8 = "passengerName-26RdZ";
var _9 = "money-2MRrO";
export { _1 as "__esModule", _2 as "item", _3 as "avatar", _4 as "select", _5 as "item_recommend", _6 as "item_active", _7 as "clear", _8 as "passengerName", _9 as "money" }
export default { "__esModule": _1, "item": _2, "avatar": _3, "select": _4, "item_recommend": _5, "item_active": _6, "clear": _7, "passengerName": _8, "money": _9 }
